import React from "react";
import {
    Card,
    CardBody,
} from "@chakra-ui/react";
import BasicCountTable from "../BasicCountTable";
import { getCurrentIntakeQuery } from "../../utils/Dates";

const LeadCount = () => {
    const reportsMatrix = [
        {
            title: 'Open',
            module: 'Leads',
            query: `leadstatus = 'Open' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Following Up',
            module: 'Leads',
            query: `leadstatus = 'Following' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'No Answer',
            module: 'Leads',
            query: `leadstatus = 'No Answer' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Invalid Number',
            module: 'Leads',
            query: `leadstatus = 'Invalid Number' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Absolutely Not Reachable',
            module: 'Leads',
            query: `leadstatus = 'Absolutely Not Reachable' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Not Interested',
            module: 'Leads',
            query: `leadstatus = 'Not Interested' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Not Qualified',
            module: 'Leads',
            query: `leadstatus = 'Not Qualified' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Mystery Shopper',
            module: 'Leads',
            query: `leadstatus = 'Mystery Shopper' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Window Shopper',
            module: 'Leads',
            query: `leadstatus = 'Window Shopper' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Future Prospect',
            module: 'Leads',
            query: `leadstatus = 'Future Prospect' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course'`
        },
        {
            title: 'Total Leads',
            module: 'Leads',
            query: `leadstatus != 'Converted' AND ${getCurrentIntakeQuery()} AND course_type = 'Main Course' `
        }
    ];

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow='hidden'
            variant='outline'
            align='center'
            borderRadius={10}
            marginX={{ base: '5px', sm: '0px', md: '5px', lg: '5px' }}
        >
            <CardBody>
                <BasicCountTable type={'ex'} reportsMatrix={reportsMatrix} />
            </CardBody>
        </Card>
    );
};

export default LeadCount;